export default {
    nav: {
        home: 'Início',
        products: 'Produtos',
        solutions: 'Soluções',
        support: 'Suporte',
        aboutUs: 'Sobre nós',
        contact: 'Fale conosco',
        software: 'Software'
    },
    hero: {
        title: 'Kooyii Smart',
        desc1: 'Podemos fornecer a personalização de APPs de casa inteligente.',
        desc2: 'Se você deseja ter um APP com o estilo da sua marca, servidores privados...',
        desc3: 'Então somos a sua melhor escolha.'
    },
    main1: {
        title: 'Página Inicial Personalizada',
        subtitle: 'O aplicativo Kooyii permite personalizar atalhos na página inicial com base em seus hábitos pessoais, facilitando o controle dos dispositivos.',
        desc1: 'A nuvem sincroniza automaticamente a data e hora locais.',
        desc2: 'Adicione câmeras à página inicial para visualizar facilmente as transmissões de vídeo. Clique para entrar e usar o PTZ para ajustar a direção da câmera.',
        desc3: 'Adicione fechaduras à página inicial para destrancá-las remotamente de forma conveniente.',
        desc4: 'A nuvem sincroniza automaticamente o clima e a temperatura locais.',
        desc5: 'Controle em lote para armar e desarmar centrais de alarme e gateways.',
        desc6: 'Adicione interruptores à página inicial para ligar/desligar as luzes rapidamente.',
        desc7: 'Adicione cortinas à página inicial para abrir/fechar/pausar rapidamente.'
    },
    main2: {
        title: 'Gerenciamento de Dispositivos',
        subtitle: 'O aplicativo Kooyii exibe os dispositivos por zona, permitindo que você os encontre e os controle mais rapidamente.',
        desc1: 'Selecionar uma zona exibirá os dispositivos naquela área.',
        desc2: 'Clique para controlar remotamente a abertura/fechamento/pausa da cortina e configurar a rotação de avanço/retrocesso.',
        desc3: 'Clique para ajustar remotamente o ligar/desligar, brilho e temperatura de cor das luzes.',
        desc4: 'Clique para adicionar/controlar TVs, aparelhos de ar condicionado, etc.',
        desc5: 'Clique para excluir dispositivos e atribuí-los a zonas específicas.',
        desc6: 'Clique para ligar/desligar as luzes remotamente, definir temporizadores de interruptor, controle duplo, etc.',
        desc7: 'Clique para armar/desarmar gateways remotamente, adicionar sub-dispositivos, definir imagens de fundo de tela desligada, etc.',
        desc8: 'Clique para operar gateways VRF para controle de ar condicionado central.'
    },
    main3: {
        title: 'Cenas Inteligentes e Automação',
        subtitle: 'Configure cenas e automações para obter uma interconexão inteligente de todos os dispositivos da casa.',
        desc1: 'Clique para alternar entre cenas e automação.',
        desc2: 'Clique para entrar na página de edição para modificar ou excluir comandos de ação dentro de uma cena.',
        desc3: 'Clique para adicionar uma cena/automação, selecione o dispositivo e a ação a executar; terá efeito após a conclusão.',
        desc4: 'Clique para executar as cenas inteligentes predefinidas com um único toque.'
    },
    about: {
        title: 'Sobre nós',
        desc1: 'Kooyii é um aplicativo móvel abrangente desenvolvido de forma independente pela Shenzhen Golden Security Technology Co., Ltd., integrando casa inteligente e alarmes de segurança. Através do aplicativo, os usuários podem adicionar e controlar dispositivos, definir cenas de automação e receber alarmes a qualquer hora e em qualquer lugar.',
        desc2: 'O aplicativo suporta o controle de dispositivos inteligentes em vários protocolos, cobrindo vários cenários de aplicação, como casas inteligentes, alarmes de segurança, hotéis inteligentes e automação predial.',
        desc3: 'Como uma empresa de alta tecnologia que integra P&D, produção e vendas, oferecemos aos clientes serviços como desenvolvimento de hardware, personalização de software e implantação privada para atender a diversas necessidades.'
    },
    protocol: {
        title: 'Protocolos Suportados',
        cards: {
            zigbee: 'O Zigbee 3.0 é um padrão de comunicação sem fio unificado introduzido pela Connectivity Standards Alliance (CSA), permitindo interoperabilidade perfeita entre marcas e redes mesh de baixo consumo, integrando protocolos de aplicativos fragmentados.',
            wifi: 'O Wi-Fi é uma tecnologia de rede sem fio reconhecida globalmente que transmite dados por meio de ondas de rádio, permitindo que os dispositivos se conectem a redes sem cabos físicos.',
            rf433: '433MHz é uma banda de rádio de baixa frequência comumente usada para dispositivos de curto alcance e baixo consumo de energia, como sistemas de alarme de segurança e interruptores inteligentes.',
            modbus: 'Modbus é um protocolo de comunicação serial amplamente utilizado na automação industrial, suportando comunicação mestre-escravo e troca de dados.',
            knx: 'KNX é uma tecnologia de barramento padrão europeu amplamente utilizada em sistemas de automação predial para edifícios inteligentes.',
            bluetooth: 'O Bluetooth é uma tecnologia sem fio para comunicação entre dispositivos, amplamente utilizada em hotéis inteligentes, casas inteligentes e outras áreas.'
        }
    },
    features: {
        title: 'O que você pode fazer com este App',
        remoteControl: {
            title: 'Controle Remoto',
            desc: 'Controle dispositivos inteligentes remotamente.'
        },
        armDisarm: {
            title: 'Armar/Desarmar',
            desc: 'Defina os modos de armar e desarmar para a central de alarme.'
        },
        alarmPush: {
            title: 'Receber Alarmes',
            desc: 'Receba notificações instantâneas no seu celular quando a central de alarme residencial for acionada.'
        },
        scenes: {
            title: 'Cenas Inteligentes',
            desc: 'Configure a execução com um toque com base nas necessidades de diferentes cenários.'
        },
        automation: {
            title: 'Automação',
            desc: 'A função de automação permite que seus dispositivos executem comandos automaticamente quando as condições correspondentes forem atendidas.'
        },
        familyShare: {
            title: 'Compartilhamento Familiar',
            desc: 'Convide membros da família para gerenciar dispositivos juntos.'
        }
    },
    services: {
        title: 'Cenários de Aplicação',
        features: {
            smartHome: {
                title: 'Casa Inteligente',
                desc: 'Rompa as limitações das casas tradicionais para criar um espaço de convivência inteligente em todos os cenários. Com suporte a vários protocolos, como Zigbee e Wi-Fi, permite a interconexão de dispositivos e a troca de cenas de forma contínua. Desbloqueie um estilo de vida altamente eficiente e conveniente com operações minimalistas, trazendo o calor da tecnologia para sua experiência de moradia.'
            },
            security: {
                title: 'Segurança Inteligente',
                desc: 'Uma central de alarme de segurança emparelhada com uma plataforma de monitoramento profissional para construir um sistema de segurança integrado. Como núcleo do sistema, a central se conecta a vários detectores (infravermelho, fumaça, botões de emergência) por meio do protocolo de 433MHz, permitindo alertas em tempo real para invasões, incêndios e emergências.'
            },
            hotel: {
                title: 'Hotel Inteligente',
                desc: 'Focada em IoT e combinada com uma plataforma de gestão de equipamentos hoteleiros, esta solução conecta quartos inteligentes, operações de recepção e serviços de quarto, oferecendo valor duplo tanto para os hóspedes quanto para a administração do hotel.'
            },
            building: {
                title: 'Automação Predial',
                desc: 'Baseada em RTU e configurada por meio de um painel de gestão, suporta a integração de dispositivos Modbus para obter facilmente monitoramento centralizado, controle inteligente e gestão de energia dos equipamentos do edifício, transformando edifícios tradicionais em inteligentes.'
            }
        }
    },
    software: {
        title: 'Software e Plataformas',
        steps: {
            cms: { title: 'Centro de Recebimento de Alarmes', desc: 'Clique para visitar' },
            kooyii: { title: 'Kooyii', desc: 'Passe o mouse para escanear e baixar' },
            elderly: { title: 'Cuidado Inteligente para Idosos', desc: 'Experiência ainda não disponível. Entre em contato com vendas para detalhes.' },
            hotel: { title: 'Hotel Inteligente', desc: 'Experiência ainda não disponível. Entre em contato com vendas para detalhes.' },
            building: { title: 'Automação Predial', desc: 'Experiência ainda não disponível. Entre em contato com vendas para detalhes.' },
            more: { title: 'Mais Cenários', desc: 'Entre em contato com nossa equipe de vendas para aconselhamento profissional.' }
        }
    },
    solutions: {
        services: {
            title: 'Nossos Serviços',
            features: {
                hardware: {
                    title: 'Personalização de Hardware',
                    desc: 'Serviços exclusivos de design e fabricação de ponta a ponta, desde as placas PCBA principais até a estética completa do dispositivo. Cobre o design de circuitos, seleção de componentes, layout de PCB, depuração funcional, moldes de invólucro, materiais e proteção estrutural.'
                },
                software: {
                    title: 'Personalização de Software',
                    desc: 'Desenvolvimento de aplicativos e sistemas web sob medida com base em suas necessidades de negócios reais, incluindo aplicativos móveis (iOS/Android), páginas web para PC e gerenciamento de back-end. Fornecendo uma solução digital altamente eficiente adaptada ao seu modelo operacional.'
                },
                server: {
                    title: 'Implantação Privada',
                    desc: 'Implante sistemas, plataformas ou aplicativos inteiramente em seus próprios servidores ou ambientes de intranet designados. Os dados e serviços funcionam de forma completamente independente, alcançando controle autônomo total.'
                }
            }
        },
        whyUs: {
            title: 'Por Que Nos Escolher?',
            benefits: {
                oneStop: {
                    title: 'Serviço Completo',
                    desc: 'Nossas soluções cobrem software e hardware com um alinhamento unificado de ponta a ponta, eliminando a coordenação entre várias partes, encurtando os ciclos de desenvolvimento e reduzindo os custos de comunicação.'
                },
                custom: {
                    title: 'Personalização Profunda',
                    desc: 'Os recursos do software são combinados com precisão ao desempenho do hardware, evitando problemas de compatibilidade e garantindo uma operação geral mais suave com taxas de falha mais baixas.'
                },
                expandable: {
                    title: 'Alta Escalabilidade',
                    desc: 'Nossos serviços reservam interfaces de expansão, tornando mais fácil para os clientes atualizar e expandir funcionalidades com base em necessidades futuras.'
                },
                deployment: {
                    title: 'Implantação Flexível',
                    desc: 'Seja uma implantação privada localizada ou implantação em nuvem pública, fornecemos soluções flexíveis para atender às suas necessidades.'
                }
            }
        },
        cta: {
            title: 'Pronto para atualizar seu estilo de vida?',
            desc: 'Fale com nossos especialistas em casas inteligentes hoje e deixe-nos projetar o ecossistema perfeito para você.',
            button: 'Falar com Vendas'
        }
    },
    product: {
        nav: {
            panel: 'Painéis de Controle',
            hub: 'Hubs Inteligentes',
            switch: 'Interruptores Inteligentes',
            curtain: 'Cortinas Inteligentes',
            sensor: 'Sensores',
            lighting: 'Iluminação Inteligente',
            security: 'Segurança Inteligente',
            doorlock: 'Fechaduras Inteligentes'
        },
        sub: {
            '4inch': '4 Polegadas',
            '5inch': '5 Polegadas',
            '6inch': '6 Polegadas',
            '7inch': '7 Polegadas',
            '8inch': '8 Polegadas',
            '10inch': '10 Polegadas',
            '1gang': '1 Tecla',
            '2gang': '2 Teclas',
            '3gang': '3 Teclas',
            '4gang': '4 Teclas',
            'wireless': 'Sem fio',
            'wired': 'Com fio',
            'openclose': 'Motor de Cortina',
            'roller': 'Persiana Rolo',
            'downlight': 'Spots e Downlights',
            'magnetic': 'Trilho Magnético',
            'strip': 'Fita LED',
            'alarm': 'Central de Alarme',
            'door': 'Sensor de Porta/Janela',
            'smoke': 'Detector de Fumaça',
            'infrared': 'Detector Infravermelho',
            'radar': 'Radar de Presença Humana',
            'water': 'Sensor de Vazamento',
            'temp': 'Sensor de Temp. e Umidade',
            'indoorCam': 'Câmera Interna',
            'outdoorCam': 'Câmera Externa',
            'password': 'Fechadura com Senha',
            'fingerprint': 'Fechadura Biométrica',
            'face': 'Fechadura com Rec. Facial'
        },
        common: {
            learnMore: 'Saiba mais',
            addToCart: 'Adicionar ao carrinho',
            buyNow: 'Comprar agora',
            emptyProduct: 'Nenhum produto relacionado no momento. Fique atento...'
        },
        cart: {
            titleList: 'Lista de Solicitações',
            titleForm: 'Informações de Contato',
            empty: 'Sua lista está vazia, vá adicionar alguns produtos!',
            delete: 'Excluir',
            totalItems: 'Total de {count} produtos selecionados',
            nextStep: 'Próximo Passo: Preencher Info',
            submit: 'Enviar Solicitação'
        },
        form: {
            name: 'Como devemos chamá-lo?',
            namePlaceholder: 'Insira seu nome',
            address: 'Endereço da Empresa',
            addressPlaceholder: 'Insira o endereço da sua empresa',
            location: 'Cidade / País',
            locationPlaceholder: 'Ex: São Paulo, Brasil',
            whatsapp: 'WhatsApp',
            whatsappPlaceholder: 'Insira seu WhatsApp',
            email: 'E-mail',
            emailPlaceholder: 'Insira seu e-mail',
            remark: 'Observações',
            remarkPlaceholder: 'Insira quaisquer observações',
            zipCode: 'CEP',
            zipCodePlaceholder: 'Insira o seu CEP'
        },
        alert: {
            fillRequired: 'Por favor, preencha todos os campos obrigatórios (*)',
            submitSuccess: 'Solicitação enviada com sucesso! Nossa equipe de vendas entrará em contato em breve.',
            confirm: 'Confirmar',
            notice: 'Aviso',
            success: 'Sucesso!',
            error: 'Erro',
            invalidRequest: 'Requisição inválida',
            rateLimit: 'Operação muito frequente. Tente novamente em {seconds} segundos.',
            invalidEmail: 'Por favor, insira um e-mail válido',
            invalidPhone: 'Por favor, insira um telefone válido',
            dangerousContent: 'O conteúdo contém caracteres inválidos. Por favor, verifique e tente novamente.',
            cartEmpty: 'Nenhum item válido no carrinho',
            securityCheck: 'Por favor, conclua a verificação de segurança primeiro',
            submitFailed: 'Falha no envio, tente novamente mais tarde'
        }
    },
    contact: {
        hero: {
            title: 'Fale Conosco',
            desc: 'Obtenha aconselhamento profissional e as soluções mais adequadas para você'
        },
        form: {
            title: 'Envie-nos uma mensagem',
            subtitle: 'Preencha o formulário abaixo e retornaremos em até 24 horas.',
            firstName: 'Nome',
            firstNamePlaceholder: 'Ex: João',
            lastName: 'Sobrenome',
            lastNamePlaceholder: 'Ex: Silva',
            email: 'E-mail corporativo',
            emailPlaceholder: "joao{'@'}empresa.com.br",
            inquiryType: 'Tipo de consulta',
            selectTopic: 'Selecione um tópico...',
            message: 'Mensagem',
            messagePlaceholder: 'Como podemos ajudá-lo?',
            submitBtn: 'Enviar Mensagem',
            sending: 'Enviando...',
            successMsg: 'Obrigado! Sua mensagem foi enviada com sucesso.'
        },
        inquiry: {
            general: 'Pergunta Geral',
            sales: 'Vendas e Distribuição',
            support: 'Suporte Técnico',
            hardware: 'OEM/ODM'
        },
        location: {
            title: 'Onde Estamos',
            officeName: 'Sede em Shenzhen',
            address: 'Sala 603, Unidade 1, Edifício 1, Praça Kailifang, Rua Lianrun, Comunidade Taoyuan, Rua Dalang, Distrito de Longhua, Shenzhen, Guangdong, China',
            phone: '+86 18926403313 Sra. Yuan'
        }
    },
    footer: {
        companyName: 'Shenzhen Golden Security Technology Co., Ltd.'
    }
}